'use strict';

angular.module('mobile-apps').controller('TranslationOrderNew', [
	'$rootScope',
	'$scope',
	'MobileApps',
	'$state',
	'EntryCount',
	'TranslationOrder',
	'Utilities',
	function (
		$rootScope,
		$scope,
		MobileApps,
		$state,
		EntryCount,
		TranslationOrder,
		Utilities
	) {

		$scope.data = {
			allApps: [],
			appCountMap: {}
		};


		/**
		 * Create and navigate to new order for the given app
		 */
		$scope.orderTranslation = function(mobileAppId) {
			console.log('orderTranslation');
			console.log(mobileAppId);

			var sendData = {};
			sendData.mobileAppId = mobileAppId;

			TranslationOrder.translationOrderCreateFromApp(sendData,
				function(response) {
					$state.go('translationOrderView', {
						mobileAppId: mobileAppId,
						orderId: response.order._id
					});
				},
				function(error) {
					Utilities.showMessageErrorResponse(error);
				}
			);
		};


		/**
		 * Initializes all the data
		 */
		function init() {

			MobileApps.query().$promise.then(
				function(data) {
					// Get the counts for all the apps
					data.forEach(function(app) {
						if (!app.permissions || app.permissions.can_create_orders !== true) {
							// Skip all adds for which no orders can be created
							return;
						}
						$scope.data.allApps.push(app);
						$scope.data.appCountMap[app._id] = EntryCount.getCountForApps({mobileAppId:app._id});
					});
				}
			).catch(function(error) {
				Utilities.showMessageErrorResponse(error);
			});

		}


		init();
	}
]);
